export enum ViewGridTopContentBlock {
  Root = 'ViewGridTopContent',
}
